import { Pagination, SearchInput } from "ui";

import { NeverSoldProductsTable } from "../../components";
import { useNeverSoldProductsList } from "../../hooks";

import styles from "./NeverSold.module.scss";

const NeverSold = () => {
  const {
    neverSoldProducts,
    isLoading,
    sorting,
    setSorting,
    refetch,
    totalItems,
    searchValue,
    page,
    setSearchValue,
    setPage
  } = useNeverSoldProductsList();

  return (
    <div className={styles.neverSold}>
      <SearchInput
        value={searchValue}
        placeholder="Search..."
        onChange={setSearchValue}
      />

      <div className={styles.neverSold_tableContainer}>
        <NeverSoldProductsTable
          products={neverSoldProducts ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          refetchNeverSoldProducts={refetch}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />
    </div>
  );
};

export default NeverSold;
